
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bai-viet/[id]",
      function () {
        return require("private-next-pages/bai-viet/[id]/index.page.tsx");
      }
    ]);
  